<template>
  <div class="user-document-links">
    <span class="user-document-links__trigger" @click="openModal">О продукте</span>

    <transition name="user-docs-fade" @after-leave="unlockBody">
      <div v-if="isOpen" class="user-document-links__overlay" @click.self="closeModal">
        <div class="user-document-links__modal" role="dialog" aria-modal="true">
          <button
            type="button"
            class="user-document-links__close"
            aria-label="Закрыть"
            @click="closeModal"
          />
          <h3 class="user-document-links__title">О продукте</h3>
          <ul class="user-document-links__list">
            <li v-for="doc in documents" :key="doc.title">
              <a :href="doc.href" target="_blank" rel="noopener noreferrer">{{ doc.title }} ↗</a>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const DOCUMENTS = [
  {
    title: 'Инструкция по установке и началу работы',
    href: 'https://profitads.ru/instrukcija-po-ustanovke/',
  },
  {
    title: 'Инструкция по эксплуатации',
    href: 'https://profitads.ru/instrukcija-po-ehkspluatacii/',
  },
  {
    title: 'Описание функциональных характеристик',
    href: 'https://profitads.ru/opisanie-funkcionalnykh-kharakteristik/',
  },
];

export default {
  name: 'UserDocumentLinks',
  data() {
    return {
      isOpen: false,
      initialBodyOverflow: null,
      initialBodyPaddingRight: null,
      documents: DOCUMENTS,
    };
  },
  beforeDestroy() {
    this.unlockBody();
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    openModal() {
      this.isOpen = true;
      this.lockBody();
      document.addEventListener('keydown', this.onKeydown);
    },
    closeModal() {
      this.isOpen = false;
      document.removeEventListener('keydown', this.onKeydown);
    },
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    },
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    },
    lockBody() {
      const body = document.body;
      const scrollbarWidth = this.getScrollbarWidth();

      this.initialBodyOverflow = body.style.overflow;
      this.initialBodyPaddingRight = body.style.paddingRight;

      body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    },
    unlockBody() {
      const body = document.body;
      if (!body) return;

      body.style.overflow = this.initialBodyOverflow || '';
      body.style.paddingRight = this.initialBodyPaddingRight || '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';

.user-document-links {
  display: flex;
  justify-content: center;
  margin-top: 1.6rem;

  &__trigger {
    font-size: 1.6rem;
    line-height: 1.9rem;
    color: var(--primary);
    cursor: pointer;
    transition: 0.3s ease-out;

    &:hover {
      opacity: 0.5;
    }
  }

  &__overlay {
    position: fixed;
    inset: 0;
    z-index: 2147483647;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background-color: rgba(0, 0, 0, 0.5);
  }

  &__modal {
    position: relative;
    width: 100%;
    max-width: 48rem;
    padding: 4rem 3.2rem 3.2rem;
    border-radius: 1.6rem;
    background-color: #fff;
    box-shadow: 0 1.2rem 3.2rem rgba(0, 0, 0, 0.12);
  }

  &__close {
    position: absolute;
    top: 1.6rem;
    right: 1.6rem;
    width: 3.2rem;
    height: 3.2rem;
    border: none;
    background: none;
    background-image: url('../assets/icons/icon-close-black.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 1.6rem;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.6;
    }
  }

  &__title {
    margin: 0 0 2.4rem;
    color: $basicBlack;
    font-size: 2.2rem;
    font-weight: 500;
    line-height: 2.8rem;
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    a {
      font-size: 1.6rem;
      line-height: 2.2rem;
      color: var(--primary);
      text-decoration: none;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 0.6;
        text-decoration: underline;
      }
    }
  }
}

.user-docs-fade-enter-active,
.user-docs-fade-leave-active {
  transition: opacity 0.25s ease;

  .user-document-links__modal {
    transition: transform 0.25s ease, opacity 0.25s ease;
  }
}

.user-docs-fade-enter,
.user-docs-fade-leave-to {
  opacity: 0;

  .user-document-links__modal {
    opacity: 0;
    transform: translateY(1.2rem) scale(0.96);
  }
}
</style>
